const STORAGE_KEY = "@sacgpt:demoAssistant";
const TTL_MS = 60 * 60 * 1000; // 1 hour

// Setter centralizado — todos os pontos que salvam o cache do demo (StepAssistants,
// DemoChatModal) devem usar este helper, pra manter o shape consistente e não perder
// email/phone (coletados no passo "Contato") dependendo de por onde a pessoa passou.
export function saveDemoAssistantData({ assistant, specialty, companyName, email, phone }) {
  const payload = {
    assistant,
    specialty,
    companyName,
    email,
    // Sempre dígitos: quem exibe é que aplica máscara (inclusive o pré-preenchimento
    // do /cadastro). Normalizar aqui protege dos callers que passam o valor já
    // mascarado, vindo direto do estado do form.
    phone: typeof phone === "string" ? phone.replace(/\D/g, "") : phone,
    timestamp: Date.now(),
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  return payload;
}

export function getDemoAssistantData() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return null;
    const data = JSON.parse(stored);
    if (Date.now() - data.timestamp > TTL_MS) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return data;
  } catch {
    return null;
  }
}

export function clearDemoAssistantData() {
  localStorage.removeItem(STORAGE_KEY);
}
